export default __webpack_public_path__ + "static/media/close.80272509.svg";